import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

function parseApiResponse(raw) {
  let d = raw
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d)
    } catch {
      return raw
    }
  }
  if (d?.body != null) {
    if (typeof d.body === 'string') {
      try {
        return JSON.parse(d.body)
      } catch {
        return d.body
      }
    }
    return d.body
  }
  return d
}

function isApiSuccess(responseData) {
  if (!responseData || typeof responseData !== 'object') return false
  const s = responseData.success
  return s === true || s === 'true' || s === 1 || s === '1'
}

function pickPdfFields(source) {
  if (!source || typeof source !== 'object') {
    return { pdfLink: '', pdfDownloadUrl: '' }
  }
  return {
    pdfLink: String(source.pdfLink || '').trim(),
    pdfDownloadUrl: String(source.pdfDownloadUrl || '').trim()
  }
}

export function extractPdfFieldsFromResponse(responseData) {
  const data = responseData?.data
  if (!data || typeof data !== 'object') return { pdfLink: '', pdfDownloadUrl: '' }
  if (data.quote && typeof data.quote === 'object') {
    return pickPdfFields(data.quote)
  }
  return pickPdfFields(data)
}

export function hasSalesQuotePdf(source) {
  const { pdfLink } = pickPdfFields(source)
  return Boolean(pdfLink)
}

export async function resolveSqPdfDownloadUrl({ pdfDownloadUrl, pdfLink, quoteId }) {
  const signedUrl = String(pdfDownloadUrl || '').trim()
  if (signedUrl) return signedUrl

  if (!String(pdfLink || '').trim()) return ''
  if (!quoteId) {
    throw new Error('Quote ID is required to fetch PDF download URL')
  }

  const response = await axios.post(API_URL, {
    action: 'get-sq-pdf-download-presigned-url',
    quoteid: quoteId
  })
  const responseData = parseApiResponse(response.data)

  if (!isApiSuccess(responseData)) {
    throw new Error(responseData?.message || 'Failed to get PDF download URL')
  }

  const fromData = extractPdfFieldsFromResponse(responseData)
  const downloadUrl =
    fromData.pdfDownloadUrl ||
    String(responseData.pdfDownloadUrl || responseData.downloadUrl || '').trim()

  if (!downloadUrl) {
    throw new Error('PDF download URL not available')
  }

  return downloadUrl
}
